<script setup lang="ts">
defineProps<{
  buttonLink?: string
}>()
</script>
<template>
  <HeroCenter
    title="Kami paham, Problem Retur Permasalahan utama yang merugikan"
    sub-title="Return Management System"
    description="KiriminAja memiliki sistem RMS dan Team CONTROL TOWER yang dapat menganalisa cepat problem pengiriman retur, dan dapat bertindak langsung kepihak kurir, sehingga mampu mengurangi rasio retur yang yang jadi permasalahan logistik."
  >
    <div class="text-center flex justify-center mt-4 lg:mt-8">
      <UiButton label="Konsultasi dengan Tim Kami" :to="buttonLink" />
    </div>
    <template #decorator>
      <OtherRmsHeroDecorator />
    </template>
  </HeroCenter>
</template>
